const trainNumbersList = {
  bindings: {
    trainNumbers: '<',
    modalOptions: '<',
    filter: '<',
    loading: '<',
    onToggle: '&',
    onDelete: '&',
    hasEdit: '<',
    isLocked: '<',
  },
  templateUrl: '/modules/pis-tool/train-numbers/train-numbers-list/train-numbers-list.html',
  controller: 'TrainNumbersListController',
};

angular
  .module('pis-tool.module')
  .component('trainNumbersList', trainNumbersList);
